import React, { useEffect, useMemo, useState } from 'react';
import DashboardContainer from './DashboardContainer';
import { useLocation, useParams } from 'react-router';
import { dashboardToPath, nameToPath } from './dashboardHelpers';
import { dashboardApi } from '../apis';
import { useQueryDashboards } from './dashboardActions';

const Dashboard = () => {
  const { name } = useParams<{ name: string }>();
  const location = useLocation();
  const sanitizedName = nameToPath(name ?? '');

  const { data: dashboards } = useQueryDashboards();
  const dashboard = (dashboards || []).find((dashboard) => dashboardToPath(dashboard) === sanitizedName);

  const [url, setUrl] = useState<string | null>(null);

  const extraProps = useMemo(() => {
    const extraProps: string[] = [];
    new URLSearchParams(location.search).forEach((value, key) => extraProps.push(`${key}=${value}`));
    return extraProps;
  }, [location.search]);

  useEffect(() => {
    if (dashboard) {
      dashboardApi.findDashboardUrl({ dashboardId: dashboard.id!, extraProps }).then(setUrl);
    }
  }, [dashboard, extraProps]);

  if (!dashboard) {
    return <div>Dashboard not found!</div>;
  }

  if (!url) {
    return <div>Dashboard URL not found!</div>;
  }

  return <DashboardContainer key={dashboard.name} dashboard={dashboard} url={url} />;
};

export default Dashboard;
